<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable">
        <b-card class="w-100pct">
          <!-- <b-card-header class="py-1 mb-2">
            <i :class="options.icon" class="text-primary mr-1"></i>
            {{ item.ref }}
            <span class="text-warning"
              >&lt;{{ selection.length ? "new" : "edit" }}&gt;</span
            >
          </b-card-header> -->
          <b-card-body class="py-0 px-0">
            <b-tabs class="gridtabs" v-model="tabindex">

              <b-tab active>

                <template #title>
                  <i class="fa fa-ticket text-orange mr-1"></i>
                  {{ item.ticketno }}
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </template>


                <p class="mt-3" v-if="selection.length == 1">
                  <b-tabs>
                    <b-tab>
                      <template #title>
                        <div class="badgecontainer pr-1 mr-1 w-60px">
                          <i :class="lines.icon" class="ml-1"></i> Sectors
                          <b-badge id="selection" variant="orange" class="edit_tab">
                            {{ lines.items.length }}</b-badge>
                          <b-tooltip target="selection" placement="bottom">{{ lines.items.length }} sector(s)
                          </b-tooltip>

                        </div>
                      </template>
                      <b-row>
                        <b-col>
                          <d-table classdivtable="availtable datatable nested" refid="lines" :icon="lines.icon"
                            :selectmode="'single'" :busy="lines.busy" :tools="lines.tools" :badges="lines.badges"
                            :fields="lines.fields" :items="lines.items" :page="lines.page" :showpages="false"
                            @load="lines_load" @click="lines_click" @select="lines_select">
                          </d-table>
                        </b-col>
                      </b-row>
                      <!-- <div class="text-danger">
                        {{ lines.item }}
                      </div> -->
                    </b-tab>
                  </b-tabs>
                </p>

                <div class="px-0 mt-2" v-if="lines.item.id">
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Vendor Locator" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.vendorlocator" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Vendor Locator" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.vendorlocator = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Flight No" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.flightno" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Flight Number" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.flightno = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Marketing Carrier" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.marketingcarrier" :debounce="lines.debounce"
                            :disabled="readonly_save" :title="lines.item.marketingcarriername"
                            placeholder="Marketing Carrier" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="
                              lines.item.marketingcarrier = ''
                              " :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Operating Carrier" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.operatingcarrier" :debounce="lines.debounce"
                            :disabled="readonly_save" :title="lines.item.operatingcarriername"
                            placeholder="Operating Carrier" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="
                              lines.item.operatingcarrier = ''
                              " :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Start DateTime" label-size="sm">
                        <b-input-group>
                          <daterangepicker style="width:auto !important" size="sm" ref="date" v-model="lines.datestart"
                            @update="item_update('startdate', $event)" :disabled="readonly_save" :opens="'right'"
                            :single-date-picker="'single'" :locale-data="{
                              direction: 'ltr',
                              format: 'dd/mm/yy HH:MM',
                              daysOfWeek: [
                                'Sun',
                                'Mon',
                                'Tue',
                                'Wed',
                                'Thu',
                                'Fri',
                                'Sat',
                              ],
                              monthNames: [
                                'January',
                                'February',
                                'March',
                                'April',
                                'May',
                                'June',
                                'July',
                                'August',
                                'September',
                                'October',
                                'November',
                                'December',
                              ],
                              firstDay: 1,
                            }" :ranges="false" :showDropdowns="true" :linkedCalendars="true" :timePicker="true"
                            :timePicker24Hour="true" :time-picker-increment="1">
                          </daterangepicker>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="readonly_save" @click="
                              lines.datestart = {
                                startDate: null,
                                endDate: null,
                              }
                              ">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <!-- <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Start DateTime" label-size="sm">
                        <b-input-group>
                          <daterangepicker style="width:auto !important" size="sm" ref="date" v-model="lines.datestart"
                            :disabled="readonly_save" :opens="'right'" :single-date-picker="'single'" :locale-data="{
                              direction: 'ltr',
                              format: 'dd/mm/yy HH:MM',
                              daysOfWeek: [
                                'Sun',
                                'Mon',
                                'Tue',
                                'Wed',
                                'Thu',
                                'Fri',
                                'Sat',
                              ],
                              monthNames: [
                                'January',
                                'February',
                                'March',
                                'April',
                                'May',
                                'June',
                                'July',
                                'August',
                                'September',
                                'October',
                                'November',
                                'December',
                              ],
                              firstDay: 1,
                            }" :ranges="false" :linkedCalendars="true" :timePicker="true" :timePicker24Hour="true"
                            :time-picker-increment="1">
                          </daterangepicker>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="readonly_save" @click="
                              lines.datestart = {
                                startDate: null,
                                endDate: null,
                              }
                              ">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col> -->

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Start City" label-size="sm">
                        <treeselect placeholder="Select city..." searchPromptText="Type at least 3 chars..."
                          v-model="lines.item.startcity" :disabled="readonly_save" :clearable="true" :async="true"
                          :load-options="treeselect_loadIATA" :show-count="true" :flatten-search-results="true"
                          :disable-branch-nodes="true" :matchKeys="['id']" :title="lines.item.startcity +
                            ' ( ' +
                            lines.item.startcityname +
                            ' )'
                            " search-nested>
                          <!-- <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }} (
                            {{ lines.item.startcityname }} )
                          </div> -->
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }} (
                            {{ node.raw.label ? node.raw.label.split('|').pop().trim() : lines.item.startcityname }} )
                          </div>
                        </treeselect>
                      </b-form-group>

                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Start Terminal" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.startterminal" :disabled="readonly_save"
                            :debounce="lines.debounce" placeholder="Start Terminal" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="
                              lines.item.startterminal = ''
                              " :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Equipment" label-size="sm">
                        <b-input-group class="treeselect_all" style="left:65px; top:-15px">
                          <i class="fa fa-leaf text-primary"></i>
                        </b-input-group>
                        <b-input-group>
                          <b-form-input v-model="lines.item.aircraft" :debounce="lines.debounce"
                            :disabled="readonly_save" :title="lines.item.aircraftname" placeholder="Equipment"
                            trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.aircraft = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="End DateTime" label-size="sm">
                        <b-input-group>
                          <daterangepicker size="sm" ref="date" v-model="lines.dateend"
                            @update="item_update('enddate', $event)" :disabled="readonly_save" :opens="'right'"
                            :single-date-picker="'single'" :locale-data="{
                              direction: 'ltr',
                              format: 'dd/mm/yy HH:MM',
                              daysOfWeek: [
                                'Sun',
                                'Mon',
                                'Tue',
                                'Wed',
                                'Thu',
                                'Fri',
                                'Sat',
                              ],
                              monthNames: [
                                'January',
                                'February',
                                'March',
                                'April',
                                'May',
                                'June',
                                'July',
                                'August',
                                'September',
                                'October',
                                'November',
                                'December',
                              ],
                              firstDay: 1,
                            }" :ranges="false" :showDropdowns="true" :linkedCalendars="true" :timePicker="true"
                            :timePicker24Hour="true" :time-picker-increment="1">
                          </daterangepicker>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="readonly_save" @click="
                              lines.dateend = {
                                startDate: null,
                                endDate: null,
                              }
                              ">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <!-- <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="End DateTime" label-size="sm">
                        <b-input-group>
                          <daterangepicker size="sm" ref="date" v-model="lines.dateend" :disabled="readonly_save"
                            :opens="'right'" :single-date-picker="'single'" :locale-data="{
                              direction: 'ltr',
                              format: 'dd/mm/yy HH:MM',
                              daysOfWeek: [
                                'Sun',
                                'Mon',
                                'Tue',
                                'Wed',
                                'Thu',
                                'Fri',
                                'Sat',
                              ],
                              monthNames: [
                                'January',
                                'February',
                                'March',
                                'April',
                                'May',
                                'June',
                                'July',
                                'August',
                                'September',
                                'October',
                                'November',
                                'December',
                              ],
                              firstDay: 1,
                            }" :ranges="false" :linkedCalendars="true" :timePicker="true" :timePicker24Hour="true"
                            :time-picker-increment="1">
                          </daterangepicker>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="readonly_save" @click="
                              lines.dateend = {
                                startDate: null,
                                endDate: null,
                              }
                              ">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col> -->

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="End City" label-size="sm">
                        <treeselect placeholder="Select city..." searchPromptText="Type at least 3 chars..."
                          v-model="lines.item.endcity" :disabled="readonly_save" :clearable="true" :async="true"
                          :load-options="treeselect_loadIATA" :show-count="true" :flatten-search-results="true"
                          :disable-branch-nodes="true" :matchKeys="['id']" :title="lines.item.endcity +
                            ' ( ' +
                            lines.item.endcityname +
                            ' )'
                            " search-nested>
                          <!-- <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }} (
                            {{ lines.item.endcityname }} )
                          </div> -->
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }} (
                            {{ node.raw.label ? node.raw.label.split('|').pop().trim() : lines.item.endcityname }} )
                          </div>
                        </treeselect>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="End Terminal" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.endterminal" :disabled="readonly_save"
                            :debounce="lines.debounce" placeholder="End Terminal" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="
                              lines.item.endterminal = ''
                              " :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Duration (HH:MM:SS)" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.duration" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Duration" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.duration = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Class Code" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.classcode" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Class Code" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.classcode = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Class Name" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.classname" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Class Name" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.classname = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Cabin" label-size="sm">
                        <b-input-group class="treeselect_all" style="left:40px; top:-15px">
                          <i class="fa fa-leaf text-primary"></i>
                        </b-input-group>
                        <b-input-group>
                          <b-form-input v-model="lines.item.cabin" :debounce="lines.debounce" :disabled="readonly_save"
                            placeholder="Cabin" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.cabin = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Emission kg CO2" label-size="sm">
                        <b-input-group class="treeselect_all" style="left:95px; top:-15px">
                          <i class="fa fa-leaf text-primary"></i>
                        </b-input-group>
                        <b-input-group>
                          <b-form-input v-model="lines.item.emission" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Emission" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.emission = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Baggage" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.baggage" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Baggage" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.baggage = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Seat Number" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.seatno" :debounce="lines.debounce" :disabled="readonly_save"
                            placeholder="Seat Number" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.seatno = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Seat Status" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.seatstatus" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Seat Status" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.seatstatus = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Meal Code" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.mealcode" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Meal Code" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.mealcode = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Meal Description" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.mealdesc" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Meal Description" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.mealdesc = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Meal Status" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.mealstatus" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Meal Status" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.mealstatus = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Distance (Miles)" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.distance" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Distance" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.distance = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>


                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Status" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.status" :debounce="lines.debounce" :disabled="readonly_save"
                            placeholder="Status" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.status = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Fare Basis" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.farebasiscode" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Fare Basis" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.farebasiscode = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Coded Status" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.codedstatus" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Coded Status" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.codedstatus = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Status Code" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.statuscode" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Status Code" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.statuscode = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <!-- <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Ticket" label-for="ticket" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="lines.item.ticketno" placeholder="Ticket" size="sm" trim
                            :disabled="readonly_save"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.ticketno = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col> -->
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Stop Overs" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.nstopovers" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Stop Overs" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.nstopovers = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Marriage Group Number" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.marriagegroupnumber" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Marriage Group Number" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="lines.item.marriagegroupnumber = ''"
                              :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Marriage Group Sequence" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="lines.item.marriagegroupsequence" :debounce="lines.debounce"
                            :disabled="readonly_save" placeholder="Marriage Group Sequence" trim></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary"
                              @click="lines.item.marriagegroupsequence = ''" :disabled="readonly_save">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                  </b-row>
                </div>

                <b-row class="mt-2" v-if="!lines.item.id">
                  <b-col cols="12" sm="6" md="4" xl="3">

                    <b-row>
                      <b-col>
                        <b-form-group label-cols="12" label="Type" label-size="sm">
                          <treeselect placeholder="Type" v-model="item.type" :clearable="false" :multiple="false"
                            :options="options_type" :matchKeys="['id']" :disabled="readonly_type">
                            <div slot="value-label" slot-scope="{ node }">
                              {{ node.raw.id }}
                            </div>
                          </treeselect>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group label-cols="12" label="Locator" label-size="sm">
                          <b-input-group>
                            <b-form-input v-model="item.locator" :debounce="lines.debounce" placeholder="Locator"
                              :disabled="readonly()"></b-form-input>

                          </b-input-group>
                        </b-form-group>
                      </b-col>

                      <!-- <b-col>
                        <b-form-group label="Error?" label-for="iserror" label-cols="12">
                          <b-form-radio-group id="iserror" :checked="item.errors > 0 ? true : false" :options="[
                            { text: 'Yes', value: true },
                            { text: 'No', value: false },
                          ]" buttons button-variant="outline-success" size="sm"
                            name="radio-btn-outline"></b-form-radio-group>
                        </b-form-group></b-col> -->
                    </b-row>
                  </b-col>


                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="TicketNo" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.ticketno" :debounce="lines.debounce" placeholder="TicketNo"
                          :disabled="readonly()"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                            @click="item.ticketno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="OriginalNo" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.originalno" :debounce="lines.debounce" placeholder="OriginalNo"
                          :disabled="readonly()"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                            @click="item.originalno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="ExchangeNo" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.exchangeno" :debounce="lines.debounce" placeholder="ExchangeNo"
                          :disabled="readonly()"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                            @click="item.exchangeno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>


                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Date Issued" label-size="sm" :disabled="readonly()">
                      <b-input-group>
                        <b-form-input :value="item.dateissued
                          ? this.$helpers.datetimefield(item.dateissued)
                          : null
                          " :disabled="readonly()"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.dateissued = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Date Void" label-size="sm" :disabled="readonly()">
                      <b-input-group>
                        <b-form-input :value="item.void_at
                          ? this.$helpers.datetimefield(item.void_at)
                          : null
                          " :disabled="readonly()" placeholder="Void At"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.void_at = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Date Refund" label-size="sm" :disabled="readonly()">
                      <b-input-group>
                        <b-form-input :value="item.refund_at
                          ? this.$helpers.datetimefield(item.refund_at)
                          : null
                          " :disabled="readonly()" placeholder="Refund At"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.refund_at = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Blocked At" label-size="sm">
                      <b-input-group>
                        <b-form-input placeholder="Blocked At" :value="item.locked_at
                          ? this.$helpers.datetimefield(item.locked_at)
                          : null
                          " :disabled="readonly()"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" class="h-29 w-30px">
                            <b-form-checkbox style="padding-left:30px; margin-top:1px" v-model="unblock" size="sm"
                              switch>
                            </b-form-checkbox>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Date Travel" label-size="sm" :disabled="readonly()">
                      <b-input-group>
                        <b-form-input :value="item.datetravel
                          ? this.$helpers.datefield(item.datetravel)
                          : null
                          " :disabled="readonly()"></b-form-input>
                        <!-- <b-form-datepicker
                            v-model="item.datetravel"
                            size="sm"
                            label-help
                            hide-header
                            locale="en-GB"
                            placeholder="Select date"
                            :disabled="readonly()"
                            :date-format-options="{
                              year: 'numeric',
                              month: 'numeric',
                              day: 'numeric',
                            }"
                          ></b-form-datepicker> -->
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.datetravel = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Flight No" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.flightno" :debounce="lines.debounce" placeholder="Flight No"
                          :disabled="readonly()"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                            @click="item.flightno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Class" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.class" :debounce="lines.debounce" placeholder="Class"
                          :disabled="readonly()"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                            @click="item.class = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Routing" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.routing" :debounce="lines.debounce" placeholder="Routing"
                          :disabled="readonly()"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                            @click="item.routing = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Emission kg CO2" label-size="sm">
                      <b-input-group class="treeselect_all" style="left:95px; top:-15px">
                        <i class="fa fa-leaf text-primary"></i>
                      </b-input-group>
                      <b-input-group>
                        <b-form-input v-model="item.emission" :debounce="lines.debounce" :disabled="readonly"
                          placeholder="Emission" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.emission = ''"
                            :disabled="readonly">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Distance (Miles)" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.distance" :debounce="lines.debounce" :disabled="readonly"
                          placeholder="Distance" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.distance = ''"
                            :disabled="readonly">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Duration (HH:MM:SS)" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.duration" :debounce="lines.debounce" :disabled="readonly"
                          placeholder="Duration" trim></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.duration = ''"
                            :disabled="readonly">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="AssociatedNo" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.associatedno" :debounce="lines.debounce" placeholder="AssociatedNo"
                          :disabled="readonly('associatedno')"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly('associatedno')"
                            @click="item.associatedno = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Passenger" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.passenger" :debounce="lines.debounce" placeholder="Name"
                          :disabled="readonly()"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                            @click="item.passenger = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Surname" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.surname" :debounce="lines.debounce" placeholder="Surname"
                          :disabled="readonly('surname')"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly('surname')"
                            @click="item.surname = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="First Name" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.firstname" :debounce="lines.debounce" placeholder="First Name"
                          :disabled="readonly('firstname')"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly('firstname')"
                            @click="item.firstname = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Title" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.title" :debounce="lines.debounce" placeholder="Title"
                          :disabled="readonly('title')"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly('title')"
                            @click="item.title = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                  <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                    RI Fields
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12" sm="12" md="12" xl="12">
                    <b-form-group label-cols="12" label="RI Line" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.line_ri" :debounce="lines.debounce" placeholder="RI Line"
                          :disabled="readonly('line_ri')"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly('line_ri')"
                            @click="item.line_ri = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Event" label-size="sm">
                      <treeselect placeholder="Select event..." v-model="item.eventcode" :clearable="true" :async="true"
                        :load-options="treeselect_loadEvent" searchPromptText="Type at least 4 chars..."
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :disabled="readonly('eventcode')">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                      <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.slac" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :disabled="readonly('slac')">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Your Ref / PO" label-for="yourref" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.yourref" placeholder="Your Ref / PO" size="sm"
                          :disabled="readonly('yourref')"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" :disabled="readonly('yourref')" variant="outline-secondary"
                            @click="item.yourref = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group :disabled="readonly('agent')" label-cols="12" label="Agent" label-size="sm">
                      <b-input-group>
                        <b-form-input v-model="item.agent" placeholder="Agent"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" :disabled="readonly('agent')"
                            @click="item.agent = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" label="Queued At" label-size="sm">
                      <b-input-group>
                        <b-form-input placeholder="Queued At" :value="item.locked_at
                          ? this.$helpers.datetimefield(item.queued_at)
                          : null
                          " :disabled="readonly()"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.queued_at = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col> -->

                </b-row>

                <b-row align-v="end" class="nopadding my-2 mt-4 background-transparent" no-gutters>
                  <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                    MI Fields
                  </b-col>
                </b-row>

                <!-- {{ mifields }} -->
                <b-row v-if="mifields.length > 0">
                  <b-col cols="12" sm="6" md="4" xl="3" v-for="(mifield, index) in mifields" :key="index">
                    <!-- <b-form-group :label="label(mifield)" label-cols="12" label-size="sm">-->
                    <b-form-group :label="$helpers.requiredlabel(requirement, mifield.label)" :class="$helpers
                      .requiredlabel(requirement, mifield.label)
                      .slice(0, 1) == '*'
                      ? 'text-danger'
                      : ''
                      " label-cols="12" label-size="sm">
                      <b-input-group>
                        <!-- :placeholder="placeholder(mifield)" :debounce="mifields.debounce" -->
                        <!-- v-model="mifields.args[mifield.key]"  -->
                        <b-form-input v-if="mifield.type == 'input'" type="text" :disabled="mifield.active == '0'"
                          size="sm" trim v-model="mifield.value" :placeholder="mifield.label"></b-form-input>

                        <!-- v-if="mifield.clearable" @click="mifields.args[mifield.key] = null"-->
                        <b-input-group-append v-if="mifield.type == 'input'" @click="mifield.value = ''">
                          <b-button size="sm" variant="outline-secondary">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>

                      <!-- && filter.options
                      :multiple="filter.multiple == true ? true : false" -->
                      <!-- v-model="mifield.args[mifield.key]" :placeholder="mifield.placeholder"-->
                      <treeselect v-if="mifield.type == 'listofvalues'" :show-count="true"
                        :flatten-search-results="true" :clearable="false" :disable-branch-nodes="true"
                        :matchKeys="['id']" search-nested :options="mifield.options" v-model="mifield.value">
                      </treeselect>

                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="mifields.length == 0">
                  <b-col>
                    There are no fields to display
                  </b-col>
                </b-row>

                <b-row class="mt-2">
                  <b-col cols="12" sm="12">
                    <b-form-group label="Tags" label-for="tags" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.tags" placeholder="Tags" size="sm"
                          :disabled="readonly_development"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" :disabled="readonly_development" variant="outline-secondary"
                            @click="item.tags = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

              </b-tab>

              <b-tab>
                <template #title>
                  <i class="fa fa-gbp text-primary mr-1"></i> Accounting
                </template>
                <p class="py-3 px-0">
                  <b-row>

                    <b-col cols="12">
                      <b-form-group label="Tax Calculation" label-for="tax_calc" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.tax_calc" placeholder="Tax Calculation" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly()" variant="outline-secondary"
                              @click="item.tax_calc = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="12">
                      <b-form-group label="Fare Calculation" label-for="farecalculation" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.farecalculation" placeholder="Fare Calculation"
                            size="sm" :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly()" variant="outline-secondary"
                              @click="item.farecalculation = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Designator" label-for="designator" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.designator" placeholder="Designator" size="sm"
                            :disabled="readonly('designator')"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly('designator')" variant="outline-secondary"
                              @click="item.designator = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Tour Code" label-for="tourcode" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.tourcode" placeholder="Tour Code" size="sm"
                            :disabled="readonly('tourcode')"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly('tourcode')" variant="outline-secondary"
                              @click="item.tourcode = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Fare Type" label-size="sm">
                        <treeselect placeholder="Fare Type" v-model="item.fare_type" :clearable="true" :multiple="false"
                          :options="options_faretype" :matchKeys="['id']" :disabled="readonly()">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Fare Indicators" label-for="fare_indicators" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.fare_indicators" placeholder="Fare Indicators"
                            size="sm" :disabled="readonly('fare_indicators')"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly('fare_indicators')" variant="outline-secondary"
                              @click="item.fare_indicators = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>


                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Group Name" label-for="groupname" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.groupname" placeholder="Group Name" size="sm"
                            :disabled="readonly('groupname')"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly('groupname')" variant="outline-secondary"
                              @click="item.groupname = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group :disabled="disabled" label-cols="12" label="Branch" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.branch" placeholder="Branch"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                              @click="item.branch = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group :disabled="disabled" label-cols="12" label="IATA No" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.iatano" placeholder="IATA No"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                              @click="item.iatano = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>


                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group
                        label="Booker"
                        label-for="booker"
                        label-cols="12"
                      >
                        <b-input-group>
                          <b-form-input
                            type="text"
                            v-model="item.booker"
                            placeholder="Booker"
                            size="sm"
                            :disabled="readonly('booker')"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              size="sm"
                              :disabled="readonly('booker')"
                              variant="outline-secondary"
                              @click="item.booker = ''"
                            >
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col> -->
                  <!-- <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group
                        label="Cost Centre"
                        label-for="costcentre"
                        label-cols="12"
                      >
                        <b-input-group>
                          <b-form-input
                            type="text"
                            v-model="item.costcentre"
                            placeholder="Cost Centre"
                            size="sm"
                            :disabled="readonly('yourref')"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              size="sm"
                              :disabled="readonly('yourref')"
                              variant="outline-secondary"
                              @click="item.costcentre = ''"
                            >
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col> -->
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Tax/Miscellaneous Fee Amount (TMFA)" label-for="tmfa" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.tmfa" placeholder="Commission Penalty" size="sm"
                            :disabled="readonly_bl"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly_bl" variant="outline-secondary"
                              @click="item.tmfa = '0.00'">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Effective Commission (EFCO)" label-for="efco" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.efco" placeholder="Effective Commission" size="sm"
                            :disabled="readonly_bl"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly_bl" variant="outline-secondary"
                              @click="item.efco = '0.00'">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Effective Commission Rate (EFRT)" label-for="efrt" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.efrt" placeholder="Effective Commission Rate"
                            size="sm" :disabled="readonly_bl"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly_bl" variant="outline-secondary"
                              @click="item.efrt = '0.00'">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>



                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Net Fare" label-for="fare" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.fare" placeholder="Net Fare" size="sm"
                            :disabled="readonly_bl"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly_bl" variant="outline-secondary"
                              @click="item.fare = '0.00'">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Tax" label-for="tax" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.tax" placeholder="Tax" size="sm"
                            :disabled="readonly_bl"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly_bl" variant="outline-secondary"
                              @click="item.tax = '0.00'">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Selling Fare (Net+Markup)" label-for="sellfare" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.fare_sell" placeholder="Selling Fare" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly()" variant="outline-secondary"
                              @click="item.fare_sell = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-for="fees" label-cols="12">
                        <div>
                          <label class="mr-1">Fees / Zone</label>
                          <span class="text-primary strong">'{{ item.zone }}'</span>
                          <span> Charges</span>
                        </div>
                        <b-input-group class="treeselect_all justify-content-end"
                          style="top: 17px; padding-right: 10px">
                          <b-form-input type="text" v-model="item.fee" placeholder="Fee" size="sm"
                            :disabled="readonly()"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="true" variant="outline-secondary" @click="item.fee = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Sales Total (Selling Fare+Tax)" label-for="fare_total" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.fare_total" placeholder="Sales Total" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" :disabled="readonly()" variant="outline-secondary"
                              @click="item.cost = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                        <treeselect placeholder="Select blac..." searchPromptText="Type at least 3 chars..."
                          v-model="item.blac" :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                          :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true"
                          :matchKeys="['id']" search-nested :disabled="readonly('blac')">
                          <div slot="value-label" slot-scope="{ node }">
                            {{ node.raw.id }}
                          </div>
                        </treeselect>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="Invoice No" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.invoiceno" :debounce="lines.debounce" placeholder="Invoice No"
                            :disabled="readonly_bl"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="readonly_bl"
                              @click="item.invoiceno = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group :disabled="disabled" label-cols="12" label="Zone" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.zone" placeholder="Zone"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                              @click="item.zone = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                  </b-row>
                </p>
              </b-tab>

              <b-tab>
                <template #title>
                  <i class="fa fa-comments-o text-primary mr-1"></i>
                  Notes</template>
                <p class="py-3 px-0">
                  <b-row>
                    <b-col cols="12">
                      <b-form-group label="Notes" label-for="notes" label-cols="12">
                        <b-form-textarea id="data" v-model="item.notes" placeholder="Notes" rows="12"
                          class="smalltextarea"></b-form-textarea>
                      </b-form-group> </b-col></b-row>
                  <b-row class="mt-1">
                    <b-col>
                      <b-button squared size="sm" variant="outline-primary" class="mr-1" @click="timestamp">
                        <i class="fa fa-comment-o"></i>
                        Add Notes
                      </b-button>
                    </b-col>
                  </b-row>
                </p>
              </b-tab>

              <b-tab v-if="idselected">
                <template #title>
                  <i class="fa fa-history text-primary mr-1"></i> Audit
                </template>
                <p class="py-3 px-0">
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="ID" label-for="id" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                            :disabled="true"></b-form-input>
                          <!-- <b-input-group-append>
                            <b-button
                              size="sm"
                              variant="outline-secondary"
                              @click="item.id = ''"
                              :disabled="true"
                            >
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append> -->
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label-cols="12" label="ETR Emailed" label-size="sm" :disabled="readonly()">
                        <b-input-group>
                          <b-form-input :value="item.emailed_at
                            ? this.$helpers.datetimefield(item.emailed_at)
                            : null
                            " :disabled="readonly()"></b-form-input>
                          <!-- <b-form-datepicker
                            v-model="item.emailed_at"
                            size="sm"
                            label-help
                            hide-header
                            locale="en-GB"
                            placeholder="Select date"
                            :disabled="readonly()"
                            :date-format-options="{
                              year: 'numeric',
                              month: 'numeric',
                              day: 'numeric',
                            }"
                          ></b-form-datepicker> -->
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.emailed_at = null">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col class="text-right">
                      <b-form-group label="Error?" label-for="iserror" label-cols="12">
                        <b-form-radio-group id="iserror" :checked="item.errors > 0 ? true : false" :options="[
                          { text: 'Yes', value: true },
                          { text: 'No', value: false },
                        ]" buttons button-variant="outline-success" size="sm"
                          name="radio-btn-outline"></b-form-radio-group>
                      </b-form-group></b-col>
                    <b-col cols="12" sm="6" md="6" xl="6">
                      <b-form-group label-cols="12" label="Reason" label-size="sm">
                        <b-input-group>
                          <b-form-input v-model="item.reason" :debounce="lines.debounce" placeholder="Reason"
                            :disabled="readonly()"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" :disabled="readonly()"
                              @click="item.reason = ''">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Created At" label-for="created_at" label-cols="12">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                              locale="en-GB" :disabled="readonly()"></b-form-datepicker>
                          </b-input-group-prepend>
                          <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                            placeholder="YYYY-MM-DD" autocomplete="off" :disabled="readonly()"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                              :disabled="readonly()">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Created By" label-for="created_by" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                            :disabled="true"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                              :disabled="readonly()">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                        <b-input-group>
                          <b-input-group-prepend>
                            <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                              locale="en-GB" :disabled="readonly()"></b-form-datepicker>
                          </b-input-group-prepend>
                          <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                            placeholder="YYYY-MM-DD" autocomplete="off" :disabled="readonly()"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                              :disabled="readonly()">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" xl="3">
                      <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                        <b-input-group>
                          <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                            :disabled="readonly()"></b-form-input>
                          <b-input-group-append>
                            <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                              :disabled="readonly()">
                              <i class="fa fa-remove"></i>
                            </b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col cols="12">
                      <b-form-group
                        label="Data"
                        label-for="data"
                        label-cols="12"
                      >
                        <vue-json-pretty
                          :deep="1"
                          :data="JSON.parse(item.data)"
                        >
                        </vue-json-pretty>
                      </b-form-group> </b-col
                  ></b-row> -->
                </p>
              </b-tab>
            </b-tabs>
          </b-card-body>


          <b-card-footer class="nopadding mt-2">
            <b-row no-gutters>
              <b-col cols="auto" class="text-left">
                <b-button squared size="sm" variant="primary" @click="saveit()"
                  v-if="user.permissions.includes('tickets.save')" :disabled="postit_disabled">
                  <i class="fa fa-check"></i>
                  Save It
                </b-button>
              </b-col>
              <b-col class="text-left ml-2 mt-1">
                <div v-if="busy">
                  <i class="fa fa-spinner fa-spin text-primary"></i>
                </div>
                <div v-else>
                  <span v-html="message"></span>
                </div>
              </b-col>
              <b-col class="text-right" cols="8">
                <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                  <i class="fa fa-chevron-left pr-1"></i>
                  Back
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer>

          <!-- <b-card-footer class="mt-2 ml-1">
            <b-row>
              <b-col class="text-left">
                <div v-if="busy">
                  <i class="fa fa-spinner fa-spin text-primary"></i>
                </div>
                <div v-else>
                  <span v-html="message"></span>
                </div>
              </b-col>
              <b-col class="text-right" cols="8">
                <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                  <i class="fa fa-chevron-left pr-1"></i>
                  Back
                </b-button>
                <b-button squared size="sm" variant="primary" @click="saveit()"
                  v-if="user.permissions.includes('tickets.save')">
                  <i class="fa fa-check"></i>
                  Save It
                </b-button>
              </b-col>
            </b-row>
          </b-card-footer> -->
        </b-card>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";
import { options } from "less";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

export default {
  name: "TicketEdit",
  components: {
    VueJsonPretty,
  },
  async mounted() {
    this.item.agent = this.user.initials;
    await this.lines_load()
  },
  data() {
    return {
      busy: false,
      tabindex: 0,
      postit_disabled: false,
      locked_at: false,
      disabled: true,
      multiple: true,
      showedit: true,
      unblock: false,
      canedit: ["surname", "firstname", "title", "agent", "eventcode", "slac", "yourref", "locked_at", "type", "associatedno"],
      line: {},
      message: "",
      options_type: [
        { id: "Charter", label: "Charter" },
        { id: "EMD", label: "EMD" },
        { id: "Lowcost", label: "Lowcost" },
        { id: "Ticket", label: "Ticket" },
        //  { id: "Refund", label: "Refund" },
        { id: "Reissue", label: "Reissue" },
        { id: "Void", label: "Void" },
      ],
      options_faretype: [
        { id: "Unknown", label: "Unknown" },
        { id: "Negotiated", label: "Negotiated" },
        { id: "Net", label: "Net" },
        { id: "Manual", label: "Manual" },
        { id: "Published", label: "Published" },
        { id: "Private", label: "Private" },
      ],
      item: {
        iserror: null,
        locked_at: null,
        ticketno: "",
        locator: "",
        dateissued: this.$moment().format("YYYY-MM-DD"),
        datetravel: this.$moment().format("YYYY-MM-DD"),
        void_at: this.$moment().format("YYYY-MM-DD"),
        refund_at: this.$moment().format("YYYY-MM-DD"),
        invoice_at: this.$moment().format("YYYY-MM-DD"),
        emailed_at: this.$moment().format("YYYY-MM-DD"),
        eventcode: null,
        slac: null,
        agent: null,
        invoiceno: "",
        flightno: "",
        exchangeno: "",
        originalno: "",
        class: "",
        routing: "",
        type: "",
        tax: 0,
        fare: 0,
        efco: 0,
        efrt: 0,
        tmfa: 0,
        fare_sell: 0,
        fare_cost: 0,
        tags: "",
        //booker: "",
        // costcentre: "",
        yourref: "",
        fee: 0.0,
        zone: "X",
        notes: "",
        fare_type: "",
        passenger: "",
        title: "",
        firstname: "",
        surname: "",
        queued: "",
        status: "",
        farecalculation: "",
        tax_calc: "",
        tourcode: "",
        branch: "",
        iatano: "",
        items: [{ name: "Passenger 1", ticketno: "abc", id: 0 }],
      },
      items: [],
      lines: {
        title: "Sectors",
        icon: "fa fa-plane text-orange",
        debounce: 500,
        busy: false,
        tools: "go,export,clipboard,clone,deleteconfirm",
        badges: [
          {
            key: "ticketno",
            type: "pill",
            class: "orange",
          },
          {
            key: "classcode",
            type: "pill",
            class: "purple",
          },
          {
            key: "classname",
            type: "pill",
            class: "purple",
          },
          {
            key: "cabin",
            type: "pill",
            class: "pink",
          },
          {
            key: "flightno",
            type: "pill",
            class: "white",
          },
          {
            key: "seatno",
            type: "pill",
            class: "white",
          },
          {
            key: "startcity",
            type: "pill",
            class: "white",
          },
          {
            key: "endcity",
            type: "pill",
            class: "white",
          },
        ],
        fields: [
          {
            key: "selected",
            label: "...",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "vendorlocator",
            label: "Al Locator",
            sortable: true,
          },
          {
            key: "description",
            label: "Name",
            sortable: true,
          },
          {
            key: "startdate",
            label: "Start DateTime",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY HH:mm:SS");
              }
              return result;
            },
          },

          {
            key: "startcity",
            label: "Start City",
            sortable: true,
          },
          {
            key: "startterminal",
            label: "Start Term",
            sortable: true,
          },
          {
            key: "enddate",
            label: "End DateTime",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .utc(false)
                  .format("DD/MM/YYYY HH:mm:SS");
              }
              return result;
            },
          },
          // {
          //   key: "endtime",
          //   label: "End Time",
          //   sortable: true,
          // },
          {
            key: "endcity",
            label: "End City",
            sortable: true,
          },
          {
            key: "endterminal",
            label: "End Term",
            sortable: true,
          },
          {
            key: "aircraft",
            label: "Aircraft",
            sortable: true,
          },

          // {
          //   key: "operatingcarrier",
          //   label: "Carrier",
          //   sortable: true,
          // },
          {
            key: "flightno",
            label: "Flight No",
            sortable: true,
          },
          {
            key: "classcode",
            label: "Class",
            sortable: true,
          },
          {
            key: "classname",
            label: "Class Name",
            sortable: true,
          },
          {
            key: "cabin",
            label: "Cabin",
            sortable: true,
          },
          {
            key: "baggage",
            label: "Bag",
            sortable: true,
          },
          {
            key: "seatno",
            label: "Seat No",
            sortable: true,
          },
          {
            key: "mealcode",
            label: "Meal Code",
            sortable: true,
          },

          {
            key: "farebasiscode",
            label: "Fare Basis",
            sortable: true,
          },
          {
            key: "distance",
            label: "Distance",
            class: "text-right",
            sortable: true,
            totalled: true,
            total: 0,
            type: "int",
          },
          {
            key: "duration",
            label: "Duration",
            sortable: true,
          },
          {
            key: "status",
            label: "?",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          // {
          //   key: "actions",
          //   label: "Actions",
          //   class: "actions",
          // },
        ],
        item: {
          id: null,
          line: null,
          ticketno: null,
          startdate: null,
          startime: null,
          startcity: null,
          startterminal: null,
          enddate: null,
          endtime: null,
          endcity: null,
          endterminal: null,
          aircraft: null,
          marketingcarrier: null,
          operatingcarrier: null,
          flightno: null,
          flightflown: false,
          nstopovers: 0,
          marriagegroupnumber: 0,
          marriagegroupsequence: 0,
          baggage: null,
          seatno: null,
          seatstatus: null,
          mealcode: null,
          mealdesc: null,
          mealstatus: null,
          classcode: null,
          classname: null,
          cabin: null,
          emission: null,
          distance: null,
          duration: null,
          vendorlocator: null,
          status: null,
          farebasiscode: null,
          codedstatus: null,
          statuscode: null,
          farecalculation: null,
          tax_calc: null,
          tourcode: null,
          branch: null,
          iatano: null,
        },
        items: [],
        selected: [],
        datestart: { startDate: null, endDate: null },
        dateend: { startDate: null, endDate: null },
      },
    };
  },
  computed: {

    readonly_save() {
      if (this.user.permissions.includes('tickets.save')) {
        return false;
      }
      return true;
    },

    readonly_bl() {
      if (this.user.permissions.includes('boughtledger.save')) {
        return false;
      }
      return true;
    },

    readonly_charter() {
      // if (this.user.permissions.includes('tickets.save') && this.item.type.toLowerCase() == 'charter' || this.item.type.toLowerCase()== 'void')

      if (this.user.permissions.includes('tickets.save') && this.item.ticketno.slice(0, 2) == 'CH' && (this.item.type.toLowerCase() == 'charter' || this.item.type.toLowerCase() == 'void')) {
        return false;
      }
      return true;
    },

    readonly_type() {
      if (this.item.type.toLowerCase() == 'refund') {
        return true
      }

      if (!this.readonly_bl) {
        return false
      }
      if (!this.readonly_charter) {
        return false
      }
      return true
    },

    readonly_development() {
      if (this.user.permissions.includes('systems.development')) {
        return false;
      }
      return true;
    },
  },
  watch: {
    "item.surname": {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          this.item.passenger = newVal.toUpperCase() + "/"
          if (this.item.firstname) {
            this.item.passenger += this.item.firstname
          }
        }
      },
    },
    "item.firstname": {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          this.item.passenger = this.item.surname.toUpperCase() + "/" + newVal.toUpperCase()
        }
      },
    },
    "item.slac": {
      async handler(newVal, oldVal) {
        if (typeof newVal === "undefined") {
          this.item.slac = ""
        }
        this.item.stype = this.item.type.toUpperCase() == 'CHARTER' ? 'Y' : 'X'
        await this.load_mifields();
      }
    },
    unblock: {
      async handler(newVal, oldVal) {
        if (newVal) {
          this.item.locked_at = this.$moment().unix() * 1000
        } else {
          this.item.locked_at = ""
        }
      }
    },
  },
  methods: {

    async lines_load() {
      let variables = {
        id: this.idselected,
        mssql: true,
        startdate: this.lines.datestart.startDate ? [this.lines.datestart.startDate, this.lines.datestart.endDate] : null,
        enddate: this.lines.dateend.startDate ? [this.lines.dateend.startDate, this.lines.dateend.endDate] : null,
      };
      console.log("variables", variables);

      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tickets($mssql: Boolean, $id: String) {
              tickets(mssql: $mssql, id: $id) {
                id
                dateissued
                invoice_at
                void_at
                refund_at
                ticketno
                locator
                slac
                blac
                passenger
                title
                firstname
                surname
                datetravel
                flightno
                class
                routing
                eventcode
                invoiceno
                type
                tax
                tax_calc
                fare
                efco
                efrt
                tmfa
                fare_cost
                fare_total
                tags
                yourref
                fee
                zone
                fare_sell
                fare_type
                fare_indicators
                queued
                status
                agent
                emailed_at
                exchangeno
                originalno
                associatedno
                line_ri
                reason
                errors
                data
                notes
                branch
                iatano
                farecalculation
                tourcode
                designator
                groupname
                emission
                duration
                distance
                locked_at
                created_at
                created_by
                updated_at
                updated_by
                items {
                  id
                  line
                  description
                  ticketno
                  startdate
                  starttime
                  startcity
                  startcityname
                  startterminal
                  enddate
                  endtime
                  endcity
                  endcityname
                  endterminal
                  aircraft
                  aircraftname
                  marketingcarrier
                  marketingcarriername
                  operatingcarrier
                  operatingcarriername
                  flightno
                  flightflown
                  nstopovers
                  baggage
                  seatno
                  seatstatus
                  mealcode
                  mealdesc
                  mealstatus
                  classcode
                  classname
                  cabin
                  distance
                  duration
                  vendorlocator
                  status
                  farebasiscode
                  codedstatus
                  statuscode
                  emission
                  marriagegroupnumber
                  marriagegroupsequence   
                  updated_by
                  updated_at
                }
              }
            }
          `,
          variables,
        });

        this.item = response.data.tickets[0];
        this.lines.items = this.item.items;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async lines_click(a, ss) {
      console.log('lines_click', a)

      let state = this.lines;

      switch (a) {
        case "selectall":
          break;
        case "go":
          await this.lines_load(0)
          break;
        case "delete":
          await this.lines_delete(ss)
          break;

      }
    },
    async lines_select(ss, tools) {
      console.log("lines_select", ss);

      let state = this.lines;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["go", "filter", "add", "export", "clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit", "clone", "notes"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }

      if (state.selected.length > 0) {
        state.item = state.selected[0]; // WHAT YOU SELECTED

        // if (state.item.startdate) {
        //   let v = this.$moment.unix(state.item.startdate / 1000).utc(false).format("YYYY-MM-DD HH:mm")
        //   this.lines.datestart = { startDate: v, endDate: v }
        // }
        // if (state.item.enddate) {
        //   let v = this.$moment.unix(state.item.enddate / 1000).utc(false).format("YYYY-MM-DD HH:mm")
        //   this.lines.dateend = { startDate: v, endDate: v }
        // }

        let v = this.$moment.utc(false).format("YYYY-MM-DD HH:mm")
        if (state.item.startdate != 'NaN') {
          v = this.$moment.unix(state.item.startdate / 1000).utc(false).format("YYYY-MM-DD HH:mm")
        }
        this.lines.datestart = { startDate: v, endDate: v }

        v = this.$moment.utc(false).format("YYYY-MM-DD HH:mm")
        if (state.item.enddate != 'NaN') {
          v = this.$moment.unix(state.item.enddate / 1000).utc(false).format("YYYY-MM-DD HH:mm")
        }
        this.lines.dateend = { startDate: v, endDate: v }

      } else {
        state.item = {}
      }

    },
    async item_update(a, v) {
      console.log(a, v)

      // CONVERT TO LONG NUMBER
      let state = this.lines;
      switch (a) {
        case "startdate":
          state.item.startdate = this.$moment(v.startDate).utc(true).valueOf().toString()
          break;
        case "enddate":
          state.item.enddate = this.$moment(v.startDate).utc(true).valueOf().toString()
          break;
      }
    },
    async lines_save(ss) {
      // MUTATION HERE 
      let variables = {
        rows: this.cleanit(ss),
      };
      console.log(variables)
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation ticketslines_save(
                $rows: [TicketItem_input]               
            ) {
              ticketslines_save(rows: $rows) {
                id
                }
            }
            `,
          variables,
        });
        this.message = "<span class='text-primary'>Saved it.</span>";

        await this.lines_load(0)

      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }
    },
    async lines_delete(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation ticketslines_delete($rows: [TicketItem_input]) {
              ticketslines_delete(rows: $rows) {
                id
                }
            }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.lines_load(0);
    },
    // WHOLE TICKET
    async saveit() {
      // this.busy = true;

      let variables = {}
      let rows = []

      let requirements = await this.mifields_requirement()
      if (requirements.length > 0) {
        this.message =
          "<span class='text-danger'>" +
          requirements.slice(0, -1) +
          " required field(s). </span>";
        this.busy = false;
        return;
      } else {
        this.message = ""
      }

      console.log('saveit', this.tabindex)
      switch (this.tabindex) {
        case 0:

          if (this.lines.item.id) {
            await this.lines_save([this.lines.item])
          } else {
            console.log('item is', this.item)
            rows = [this.cleanit(this.item)];

            for (var key in rows[0]) {
              if (!this.canedit.includes(key) && key != "id") {
                delete rows[0][key];
              }
              if (key == "locked_at") {
                rows[0].locked_at = this.$moment().format("YYYY-MM-DD HH:mm:ss")
              }
            }

            if (this.mifields.length > 0) {
              let tags = JSON.parse(this.item.tags || "{}");
              for (var k = 0; k < this.mifields.length; k++) {
                tags[this.mifields[k].key] = this.mifields[k].value;
              }
              rows[0].tags = JSON.stringify(tags);
            }

            variables = {
              rows,
            };
            console.log("variables", variables);

            try {
              const response = await this.$apollo.mutate({
                mutation: gql`
                  mutation tickets_save($rows: [Ticket_input], $dateformat: String) {
                    tickets_save(rows: $rows, dateformat: $dateformat) {
                      id
                    }
                  }
                `,
                variables,
              });
              this.message = "<span class='text-primary'>Saved it.</span>";
            } catch (error) {
              this.message = "<span class='text-danger'>" + error.message + "</span>";
            }
          }
          break;

        case 1:

          variables = {
            rows: [{ id: this.item.id, fare: (parseFloat(this.item.fare ? this.item.fare : 0) * 100).toFixed(0), tax: (parseFloat(this.item.tax ? this.item.tax : 0) * 100).toFixed(0), efco: (parseFloat(this.item.efco ? this.item.efco : 0) * 100).toFixed(0), efrt: (parseFloat(this.item.efrt ? this.item.efrt : 0) * 100).toFixed(0), tmfa: (parseFloat(this.item.tmfa ? this.item.tmfa : 0) * 100).toFixed(0), invoiceno: this.item.invoiceno, tags: this.item.tags, notes: this.item.notes }],
          };
          console.log("variables", variables);

          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
            mutation tickets_save($rows: [Ticket_input], $dateformat: String) {
              tickets_save(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
              variables,
            });
            this.message = "<span class='text-primary'>Saved it.</span>";
          } catch (error) {
            this.message = "<span class='text-danger'>" + error.message + "</span>";
          }
          break;

        case 2:
          variables = {
            rows: [{ id: this.item.id, notes: this.item.notes }],
          };
          console.log("variables", variables);
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
            mutation tickets_save($rows: [Ticket_input], $dateformat: String) {
              tickets_save(rows: $rows, dateformat: $dateformat) {
                id
              }
            }
          `,
              variables,
            });
            this.message = "<span class='text-primary'>Saved it.</span>";
          } catch (error) {
            this.message = "<span class='text-danger'>" + error.message + "</span>";
          }
          break;
      }

      this.busy = false;
      await this.lines_load(0);
    },
    readonly(property) {
      let result = true;
      if (this.user.permissions.includes("tickets.save")) {
        this.canedit.forEach(function (action, index) {
          if (property == action) {
            result = false;
          }
        });
      }
      return result;
    },

  },
};
</script>
